<template>
  <div class="login-page">
    <div class="login-mask" />
    <el-card class="login-card">
      <div class="title">商户后台</div>
      <div class="subtitle">商户管理员登录</div>
      <el-form :model="form" label-position="top">
        <el-form-item label="账号">
          <el-input v-model="form.username" placeholder="请输入商户管理员账号" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" type="password" show-password placeholder="请输入登录密码" />
        </el-form-item>
        <el-button type="primary" class="submit-btn" :loading="submitting" @click="submit">登录</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { login } from '../api/auth';
import { setToken } from '../utils/auth';
import { loginErrorMessage } from '../utils/loginError';

export default {
  data() {
    return { form: { username: '', password: '' }, submitting: false };
  },
  methods: {
    async submit() {
      if (!this.form.username.trim() || !this.form.password) {
        this.$message.warning('请输入账号和密码');
        return;
      }
      this.submitting = true;
      try {
        const { data } = await login(this.form);
        if (!data || !data.data || !data.data.token) {
          this.$message.error('登录失败，请稍后重试');
          return;
        }
        setToken(data.data.token);
        this.$router.replace('/dashboard');
      } catch (err) {
        this.$message.error(loginErrorMessage(err));
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #00a870 0%, #3dc88f 40%, #75e0b0 100%);
}

.login-mask {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.35), transparent 45%);
}

.login-card {
  width: 440px;
  border-radius: 14px;
  position: relative;
  z-index: 1;
}

.title {
  font-size: 24px;
  font-weight: 700;
  color: #1f2d3d;
}

.subtitle {
  margin: 6px 0 14px;
  color: #909399;
}

.submit-btn {
  width: 100%;
  margin-top: 8px;
}
</style>

